import DivContainerBody from "../../../../components/DivContainerBody";
import DividerWithText from "../../../../components/DividerWithText";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../components/buttons/IconButtons";
import {DEVICE_MODEL_NAME, STEPS_CREATE_DEVICE} from "../Model/Model";
import {Box, InputAdornment} from "@mui/material";
import {CustomTextField} from "../../../../components/CustomTextField";
import React, {useEffect} from "react";
import { DIGITS_REGEX } from "../../../../Apis/functions";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */

const SectionCreateDeviceRelay  = ({data, handleChange, t, emptyFields, id, handleClear, disabled}) => {

    const enabled_devices = [
        DEVICE_MODEL_NAME.TELPO_F10,
        DEVICE_MODEL_NAME.ARATEK_BA8300
    ]

    const isEnabledDevice = enabled_devices.includes(data?.data?.deviceType);
    const keepOpenValue = isEnabledDevice
        ? (data?.relay?.keepOpenRelay >= 1 ? data?.relay?.keepOpenRelay : 1)
        : 0;

    useEffect(() => {
        if (!isEnabledDevice) {
            handleChange(
                { target: { value: 0 } },
                "keepOpenRelay",
                'relay'
            );
        } else {
            if (!data?.relay?.keepOpenRelay || data.relay.keepOpenRelay < 1) {
                handleChange(
                    { target: { value: 1 } },
                    "keepOpenRelay",
                    'relay'
                );
            }
        }
    }, [data?.data?.deviceType]);

    return (
        <DivContainerBody>
            <div className={"row"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {id !== undefined ? (
                        ''
                    ) : (
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cud_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClear(STEPS_CREATE_DEVICE.RELAY.INDEX);
                            }}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    )}
                </div>
                <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField
                        id='txt_cud_delay_to_open'
                        name='delayToOpen'
                        emptyFields={emptyFields}
                        isValidText={'this_value_must_be_greater_than_0'}
                        value={data?.relay?.delayToOpen ?? 0}
                        type = 'number'
                        trans='delay_to_open'
                        required={enabled_devices.includes(data?.data?.deviceType)}
                        onBlur={(e) => {
                            if (e.target.value === '') {
                                handleChange(
                                    { target: { value: 0 } },
                                    "delayToOpen",
                                    'relay'
                                );
                            }
                        }}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (DIGITS_REGEX.test(value) && (value === '' || Number(value) >= 0)) {
                                handleChange(e, "delayToOpen", 'relay');
                            }
                        }}
                        length={4}
                        disabled={disabled || !enabled_devices.includes(data?.data?.deviceType)}
                        helperText={'this_value_must_be_greater_than_0'}
                        InputProps={{
                            min: 0,
                            endAdornment: <InputAdornment position='end'>{t('sec')}</InputAdornment>,
                        }}
                    />
                </Box>
                <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <CustomTextField
                        id="txt_cud_keep_open_relay"
                        name="keepOpenRelay"
                        trans="keep_open_relay"
                        required={isEnabledDevice}
                        value={keepOpenValue}
                        type="number"
                        onBlur={(e) => {
                            if (!isEnabledDevice) return;

                            if (e.target.value === '' || Number(e.target.value) < 1) {
                                handleChange(
                                    { target: { value: 1 } },
                                    "keepOpenRelay",
                                    'relay'
                                );
                            }
                        }}
                        onChange={(e) => {
                            if (!isEnabledDevice) return;

                            const value = e.target.value;

                            if (value === '' || Number(value) >= 1) {
                                handleChange(e, "keepOpenRelay", 'relay');
                            }
                        }}
                        disabled={disabled || !isEnabledDevice}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {t("sec")}
                                </InputAdornment>
                            )
                        }}
                        length={4}
                        helperText={t("this_value_must_be_greater_than_0")}
                    />
                </Box>
            </div>
        </DivContainerBody>
    );
}

export default SectionCreateDeviceRelay
